module.exports = __webpack_public_path__ + "static/fonts/realiance-icons.a4aaa556.ttf";